<template>
    <master-layout>
        <div class="breadcamb_box m-b-15">
            <div>
                <h4 class="page-title"><i class="ti-plug"></i> {{ $t('integrations') }} </h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card-box">
                    <input v-model="listConfig.filter" class="form-control" :placeholder="$t('search') + `...`" />
                </div>
            </div>
            <div class="col-md-12">
                <PmlItem v-for="item in list" :key="item.id" :item="item" :enabled="enabled" v-pml-block="isLoading && item.available"></PmlItem>
                <p class="t_center m-t-30" v-if="!list.length"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</p>
            </div>
        </div>
    </master-layout>
</template>

<script>
    import PmlItem from './Item.vue'
    import Notify from 'utils/helpers/notify'
    import TableFilters from 'utils/mixins/table-filters'
    import { trans } from 'utils/helpers/translation'
    import { getAll } from 'services/integrations'

    export default {
        name: 'Integrations',
        components: { PmlItem },
        mixins: [ TableFilters ],
        data () {
            return {
                listConfig: {
                    filter: '',
                    orderProp: 'name',
                    orderDir: 'asc',
                    columns: ['tags']
                },
                enabled: [],
                isLoading: false,
                items: [
                    {
                        slug: 'ical',
                        available: true,
                        module: 'iCal',
                        icon: 'ti-calendar',
                        tags: 'google calendar outlook agenda calendario ics ical tasks sync'
                    },
                    {
                        slug: 'mail-trap',
                        available: true,
                        beta: true,
                        module: 'MailTrap',
                        icon: 'ti-email',
                        tags: 'auto track trap emails e-mails external externo'
                    },
                    {
                        slug: 'in-forms',
                        available: true,
                        beta: false,
                        module: 'InForms',
                        icon: 'ti-pencil-alt',
                        tags: 'web in forms auto leads deals capture external externo'
                    },
                    {
                        slug: 'facebook-leads',
                        available: true,
                        beta: true,
                        module: 'FacebookLeads',
                        icon: 'fa fa-facebook',
                        tags: 'facebook lead ads'
                    },
                    {
                        slug: 'rd-station',
                        available: true,
                        beta: false,
                        module: 'RdStation',
                        icon: 'ti-id-badge',
                        tags: 'rd station auto automatically face'
                    },
                    {
                        slug: 'zapier',
                        available: true,
                        beta: true,
                        module: 'Zapier',
                        icon: 'fa fa-gear',
                        tags: 'zapier multi integration auto automatically face'
                    }
                ]
            }
        },
        metaInfo () {
            return {
                title: trans('integrations')
            }
        },
        mounted () {
            this.isLoading = true
            getAll()
                .then(response => { this.enabled = response.data.enabled })
                .catch(() => { Notify.error(trans('_notifications.error')) })
                .then(() => { this.isLoading = false })
        },
        computed: {
            records () {
                return this.items || []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/Main.vue